import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface GetAlertIntervalState {
    getalertinterval: {
        load: boolean;
        data: [];
    };
    levelsdata: {
        load: boolean;
        data: [];
    };
}

export const GetAlertIntervalSlice = createSlice({
    name: "getalertinterval",
    initialState: {
        getalertinterval: {
            load: false,
            data: [],
        },
        levelsdata: {
            load: false,
            data: [],
        },
    } as GetAlertIntervalState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(fetchAlertInterval.pending, (state: GetAlertIntervalState) => {
                state.getalertinterval.load = true;
            })
            .addCase(fetchAlertInterval.fulfilled, (state: GetAlertIntervalState, action: any) => {
                state.getalertinterval.data = action.payload;
                state.getalertinterval.load = false;
            })
            .addCase(fetchAlertInterval.rejected, (state: GetAlertIntervalState) => {
                state.getalertinterval.load = false;
            })
            .addCase(fetchLevelsData.pending, (state: GetAlertIntervalState) => {
                state.levelsdata.load = true;
            })
            .addCase(fetchLevelsData.fulfilled, (state: GetAlertIntervalState, action: any) => {
                state.levelsdata.data = action.payload;
                state.levelsdata.load = false;
            })
            .addCase(fetchLevelsData.rejected, (state: GetAlertIntervalState) => {
                state.levelsdata.load = false;
            });
    },
});

export default GetAlertIntervalSlice.reducer;

export const fetchAlertInterval = createAsyncThunk(
    "getalertintervalcount/fetchAlertInterval",
    async (param: any) => {
        try {
            const { data } = await DataServer.get("api/GetNotificationAlertIntervals?warehouse_id=" + param.apiParam.warehouse_id + "&notification_category=" + param.apiParam.notification_category + "&category_status=" + param.apiParam.category_status);
            return data.data;
        } catch (error) {
            
        }
    }
);

export const fetchLevelsData = createAsyncThunk(
    "getalertintervalcount/fetchLevelsData",
    async (param: any) => {
        try {
            const { data } = await DataServer.post("api/getLevelsData", {
                warehouse_id: param.apiParam.warehouse_id
            });
            return data.data;
        } catch (error) {
            
        }
    }
);